import request from '../http';

/**
 * 素材消耗报表 - 分页查询
 * 对接后端 /report/material-consumptions
 * 默认近 7 天无筛选时后端需广告层现算，单独加长超时（与消耗明细导出同级），避免全局 20s 误报。
 */
export const listMaterialConsumption = (params) =>
  request({ url: '/report/material-consumptions', method: 'get', params, timeout: 120000 });

/** 素材消耗报表 - 上传人下拉 */
export const queryUploaderOptions = () =>
  request({ url: '/report/material-consumptions/uploader-options', method: 'get' });

/**
 * 素材消耗报表 - Excel 导出
 * 对接后端 /report/material-consumptions/export
 */
export const exportMaterialConsumption = (params) =>
  request({
    url: '/report/material-consumptions/export',
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 180000
  });
